import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tree_folder",
  "use": "tree_folder-usage",
  "viewBox": "0 0 12 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 10\" id=\"tree_folder\"><path d=\"M.992 0h3.074L6.05 2h4.958c.595 0 .992.4.992 1v6c0 .6-.397 1-.992 1H.992C.397 10 0 9.6 0 9V1c0-.6.397-1 .992-1z\" fill=\"#C1C6D3\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol